module.exports = __webpack_public_path__ + "static/truck-promo-c431537d72bef795fefb83f994de5fb8.png";